export enum DisasterTypeKey {
  drought = 'drought',
  flashFloods = 'flash-floods',
  floods = 'floods',
  malaria = 'malaria',
  typhoon = 'typhoon',
}
